import { render, staticRenderFns } from "./HomeProductsDesktop.vue?vue&type=template&id=afeaf97c&scoped=true&"
import script from "./HomeProductsDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeProductsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductsDesktop.vue?vue&type=style&index=0&id=afeaf97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeaf97c",
  null
  
)

export default component.exports